import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Store } from '@ngrx/store';

import { selectVideoCall } from '../../../../store/app.selectors';
import { MessagingEnvironmentService } from '../../../../core/services/messaging-environment.service';
import { IVideoCallSettings } from '../../interfaces/IVideoCallMember';
import { setVideoCall } from '../../store/chat.actions';
import { AppStateWithChat } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-call-recive',
  templateUrl: './call-recive.component.html',
  styleUrls: ['./call-recive.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CallReciveModalComponent {
  @Input() room: string;

  private store = inject(Store<AppStateWithChat>);
  dialModalRef = inject(MatDialogRef<CallReciveModalComponent>);
  private env = inject(MessagingEnvironmentService);
  data = inject<{ client: { uid: string; displayName: string }; roomId: string }>(MAT_DIALOG_DATA);

  videoCall = toSignal(this.store.select(selectVideoCall), { initialValue: null as IVideoCallSettings | null });
  ringtone = new Audio(`${this.env.env.assetsNgxMessaging}/sounds/ringtone.mp3`);

  loadSounds(): void {
    this.ringtone.load();
    this.ringtone.addEventListener(
      'ended',
      function () {
        this.currentTime = 0;
        this.play();
      },
      false
    );
    this.ringtone.play();
    setTimeout(() => {
      this.cancel();
    }, 28000);
  }

  cancel(): void {
    this.ringtone.pause();
    this.dialModalRef.close();
  }

  async goCall(): Promise<void> {
    this.ringtone.pause();
    if (this.videoCall()) {
      this.store.dispatch(setVideoCall({ videoCall: null }));
      await this.delay(1000);
    }
    this.store.dispatch(
      setVideoCall({ videoCall: { room: this.data.roomId, name: this.data.client.displayName, type: 1 } })
    );
    this.dialModalRef.close();
  }

  delay(time: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, time));
  }
}
